import { ConfiguracionFormattDate } from 'api/configuraciones/ConfigModelFormatters';
import moment from 'moment';
import CRUDgeneric from 'utils/CRUDgeneric';
import { formatReceived } from 'utils/formatValues';

export const URIconfiguradorNombramientosFormato = '/catalogos/formatos-de-nombramiento/';
const _cliente = CRUDgeneric(URIconfiguradorNombramientosFormato);
const _nameModel = 'Formato';
const _nameModelSingular = 'el Formato';

const _formatRecordForRead = (record) => {
  const recordRequest = {
    ...formatReceived(record),
    vigencia_inicial: record?.vigencia_inicial
      ? moment(record?.vigencia_inicial)
      : null,
    // Convierte la fecha de vigencia final a objeto moment si existe, si no null
    vigencia_final: record?.vigencia_final
      ? moment(record?.vigencia_final)
      : null,

  };
  return recordRequest;
};
const _formatRecordForSend = (record) => {
  const recorResponse = ConfiguracionFormattDate(record);
  if (recorResponse.vigencia_inicial?.format) {
    recorResponse.vigencia_inicial = record.vigencia_inicial.format('YYYY-MM-DD');
  }
  return recorResponse;
};
/**
 * GET NombramientosTipoDeContratacion
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConfiguradorNombramientosFormato = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);
// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelConfiguradorNombramientosFormato = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: { // el actor que formatea.
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};
